import React from "react";
import { withFormik, Form } from "formik";
import { Link } from "react-router-dom";
import { FormikField } from "../..";
import Constant from "../../../utils/constant";
import { emailPattern } from "../../../config/const";

const ForgotPasswordDetailForm = (props) => {
  const { errors, touched } = props;
  return (
    <Form className="form-container">
      <FormikField
        label="Enter your registered Email address"
        placeholder="eg:school@dummy.com"
        name="email"
        type="email"
        errorText={errors.email}
        touched={touched.email}
        component="input"
      />
      <div
        className={`form-item form-button-item ${
          errors.email ? "opacity07" : ""
        }`}
      >
        <button disabled={errors.email}>Reset</button>
      </div>
      <div className="not-registered">
        <Link className="forgot-link-container" to="/contactUs">
          <div>Contact Support</div>
        </Link>
      </div>
    </Form>
  );
};

export const ForgotPasswordForm = withFormik({
  mapPropsToValues: (props) => {
    return {
      email: props?.email || "",
    };
  },
  validate: (values) => {
    let errors = {};
    if (!values.email) {
      errors.email = Constant.EMPTY_EMAIL;
    } else if (!emailPattern.test(values.email)) {
      errors.email = Constant.INVALID_EMAIL;
    }
    return errors;
  },
  handleSubmit: (values, { props }) => {
    props?.submitForget(values);
  },
})(ForgotPasswordDetailForm);
